export default function DictionaryItem(...args) {
  return `${args.join('__')}` || 'DictionaryItem';
}
